module.exports = __webpack_public_path__ + "img/cubiertos.3b5e1fe3.png";